import React from 'react';
import '../styles/LanguageBadges.css';

const LanguageBadges = () => {
  const languages = [
    { code: 'es', name: 'Spanish' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'it', name: 'Italian' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'ru', name: 'Russian' },
    { code: 'zh', name: 'Chinese' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'ar', name: 'Arabic' },
    { code: 'hi', name: 'Hindi' },
    { code: 'tr', name: 'Turkish' },
    { code: 'pl', name: 'Polish' },
    { code: 'nl', name: 'Dutch' },
    { code: 'sv', name: 'Swedish' },
    { code: 'uk', name: 'Ukrainian' },
  ];

  return (
    <div className="language-badges">
      {languages.map((lang) => (
        <div key={lang.code} className="language-badge">
          <span className="language-code">{lang.code.toUpperCase()}</span>
          <span className="language-name">{lang.name}</span>
        </div>
      ))}
      <div className="language-badge more">
        <span>+12</span>
        <span className="language-name">More</span>
      </div>
    </div>
  );
};

export default LanguageBadges;
